import React from 'react';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';

import { IconArrowRight } from '../../../Common/Icon';

import styles from './index.module.scss';

export default function JoinOurCommunity(): React.ReactNode | null {
  const navigate = useNavigate();

  return (
    <div className={styles.footer}>
      <div>
        <h2 style={{ textAlign: 'center' }}>
          Join our <span>international community</span> where people from all
          countries
          <br />
          <span>share how much they tip</span> at restaurants.
        </h2>
      </div>
      <Button
        icon={<IconArrowRight />}
        style={{ fontWeight: 700 }}
        type="primary"
        size="large"
        onClick={() => navigate('/international')}
      >
        Go To International Community
      </Button>
    </div>
  );
}
